import { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { useNavigate, useParams } from "react-router-dom";
import T4Payroll from "../t4payroll/T4Payroll";
import EmployerT4Payroll from "../t4payroll/EmployerT4Payroll";
import T4Summary from "../t4payroll/T4Summary";
import T4xml from "../t4payroll/T4xml";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import EmployeeSummary from "../t4payroll/Employee-Earning-Summary";
import PayrollLiabBalance from "../t4payroll/Payroll-Liab-Balance";
import PayrollTransactionDetails from "../t4payroll/Payroll-Transaction-Details";
import EmployeeEarningSummary from "../t4payroll/Employee-Earning-Summary";
import RecordOfEmployment from "../t4payroll/Record-of-employment(ROE)";

export const T4ClientTab = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const navigate = useNavigate();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";
  const userLogedIn = userRole === "User";

  return (
    <>
      <AppBreadcrumb
        currentMenu={
          activeIndex == 0
            ? "Employee T4"
            : activeIndex == 1
              ? "Employer T4"
              : activeIndex == 2
                ? "T4 Summary"
                : activeIndex == 3
                  ? "T4 XML"
                  : activeIndex == 4
                    ? "Employee Earning Summary"
                    : activeIndex == 5
                      ? "Payroll Liab Balance"
                      : activeIndex == 6
                        ? "Payroll Transaction Details"
                        : "ROE (Record Of Employment)"
        }
        pageName="List"
        pageTitle="Reports"
        goToPage={!!userLogedIn}
      />
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Employee T4">
          <T4Payroll />
        </TabPanel>
        <TabPanel header="Employer T4">
          <EmployerT4Payroll />
        </TabPanel>
        <TabPanel header="T4 Summary">
          <T4Summary />
        </TabPanel>
        <TabPanel header="T4 XML">
          <T4xml />
        </TabPanel>
        <TabPanel header="Employee Earning Summary">
          <EmployeeEarningSummary />
        </TabPanel>
        <TabPanel header="Payroll Liab Balance">
          <PayrollLiabBalance />
        </TabPanel>
        <TabPanel header="Payroll Transaction Details">
          <PayrollTransactionDetails />
        </TabPanel>
        <TabPanel header="ROE (Record Of Employment)">
          <RecordOfEmployment />
        </TabPanel>
      </TabView>
    </>
  );
};
